import React from "react";
import "./About.css";

const About = () => {
  return (
    <section className="about-page">
      <div className="about-container">
        <h2 className="about-title">About Us</h2>

        <div className="about-text">
          <p><strong>Welcome to Never Better</strong></p>

          <p>
            Never Better is a professional event management and creative services
            company delivering high-quality solutions for corporate, social, and
            private occasions. We provide complete event planning, concept design,
            production, décor, branding, and on-site coordination.
          </p>

          <p>
            Our team creates customized event experiences with strong attention to
            detail, elegant styling, and smooth execution. From intimate gatherings
            to large-scale celebrations, every project is handled with creativity,
            professionalism, and care.
          </p>

          <p>
            We are committed to delivering exceptional service and memorable results,
            always placing client satisfaction at the center of everything we do.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;